function readPrefill() {
  try { return JSON.parse(localStorage.prefillDataHeader || '{}') || {} } catch { return {} }
}
function writePrefill(updater) {
  const current = readPrefill()
  const next = typeof updater === 'function' ? updater(current) : updater
  localStorage.prefillDataHeader = JSON.stringify(next || {})
}

export default {
  /**
   * Theme and Layout
   */
  globalTheme: (state, theme) => {
    state.globalTheme = theme
  },
  setRTL: (state, isRTL) => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr'
    state.isRTL = isRTL
  },
  formValid(state, data) {
    state.formValid = data
  },
  selectedLang(state, data) {
    state.selectedLang = data
  },
  isLoggedIn(state, data) {
    state.isLoggedIn = data
  },
  defaultFrontend(state, data) {
    state.defaultFrontend = data
  },
  savedLocations(state, data) {
    state.savedLocations = data
  },
  userSettings(state, data) {
    state.userSettings = data
  },
  pushSnackbar(state, payload) {
    state.snackbarQueue.push(payload)
  },
  shiftSnackbar(state) {
    state.snackbarQueue.shift()
  },
  setTagHeaderFilter(state, payload) {
    state.tagHeaderFilter = payload
    writePrefill(prev => {
      const next = { ...(prev || {}) }
      next.tagHeaderFilter = payload
      return next
    })
  },
  clearTagHeaderFilter(state) {
    state.tagHeaderFilter = { tags: [], ids: [] }
    writePrefill(prev => {
      const next = { ...(prev || {}) }
      delete next.tagHeaderFilter
      return next
    })
  },
  processPushUndo(state, payload) {
    const newProcessString = JSON.stringify(payload.process)
    const lastProcessUndoValueString = state.processUndoStack?.length
      ? JSON.stringify(state.processUndoStack[state.processUndoStack.length - 1])
      : ''

    if (newProcessString === lastProcessUndoValueString) {
      return
    }

    state.processUndoStack.push(JSON.parse(newProcessString))
  },
  processUndo(state) {
    if (state.processUndoStack.length > 1) {
      const lastState = state.processUndoStack[state.processUndoStack.length - 2]

      state.processRedoStack.push(JSON.parse(JSON.stringify(state.processUndoStack[state.processUndoStack.length - 1])))
      state.processUndoStack.pop()
      state.processCurrent = { ...lastState }
    }
  },
  processRedo(state) {
    if (state.processRedoStack.length > 0) {
      const nextState = state.processRedoStack[state.processRedoStack.length - 1]

      state.processUndoStack.push(JSON.parse(JSON.stringify(nextState)))

      state.processCurrent = { ...nextState }

      state.processRedoStack.pop()
    }
  },
  processClearRedo(state) {
    state.processRedoStack = []
  },
  /* End Process undo/redo */
  saveResourceToRestoreAfterDelete(state, payload) {
    state.resourceToRestoreAfterDelete = payload
  },
  clearResourceFromRestoreAfterDelete(state) {
    state.resourceToRestoreAfterDelete = null
  },
  saveOtherEditingSessions(state, sessions) {
    state.otherEditingSessions = sessions
  },
  clearEditingSessions(state) {
    state.otherEditingSessions = []
  },
  setStepCache(state, { processId, stepId, data }) {
    if (!state.stepCache[processId]) {
      state.stepCache[processId] = {};
    }
    state.stepCache[processId][stepId] = data;
  },
  clearStepCache(state, { processId, stepId }) {
    if (state.stepCache[processId]) {
      delete state.stepCache[processId][stepId];
    }
  },
  clearStepCacheOnUnmount(state, { processId }) {
    if (state.stepCache[processId]) {
      delete state.stepCache[processId];
    }
  },
  setUserRoles(state, roles) {
    state.userRoles = roles || []
  },
  setUserPrimaryRole(state, role) {
    state.userPrimaryRole = role || null
  },
  setOAuth(state, data) {
    state.isOAuth = data
  },
  toggleFavorite(state, routeLink) {
    if (!state.userSettings) {
      state.userSettings = { favorites: [] }
    } else if (!state.userSettings.favorites) {
      state.userSettings.favorites = []
    }
    const index = state.userSettings.favorites.indexOf(routeLink)
    if (index === -1) {
      state.userSettings.favorites.push(routeLink)
    } else {
      state.userSettings.favorites.splice(index, 1)
    }
  },
  setFavorites(state, favorites) {
    if (!state.userSettings) {
      state.userSettings = { favorites: favorites || [] }
    } else {
      state.userSettings.favorites = favorites || []
    }
  },
  setNavigationSource(state, source) {
    state.navigationSource = source
  }
}
